/* eslint-disable react/require-default-props */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getComponentName } from '../utils/utils';

class ErrorBoundary extends Component {

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  state = {};

  componentDidCatch = (error, info) => {
    console.log(error);// eslint-disable-line
    const { id = null, name = null, onError = null } = this.props;
    const { componentStack } = info || {};
    const componentName = getComponentName(componentStack);

    if (onError) {
      onError({ error, id, info, name });
    }
    if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS?.trigger) {

      window.LIFE_CYCLE_EVENT_BUS.trigger('error-boundary.error', {
        componentName,
        componentStack,
        error,
        id,
        name
      });
    }
    return null;
  };

  render() {
    const { children } = this.props;
    const { hasError } = this.state;
    if (hasError) {
      return null;
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
  name: PropTypes.string,
  onError: PropTypes.func
};

ErrorBoundary.displayName = 'ErrorBoundary';

export { ErrorBoundary };
